import React, { FC, useMemo, useState } from 'react';
import { Box } from '@src/atoms/Box';
import { Collapse } from '@src/atoms/Collapse';
import { SEPARATOR } from './const';
import { IShowMoreProps } from './models';
import { separateContent } from './utils';
import { ShowMoreButton } from './_Button/ShowMoreButton';
import { ShowMoreItem } from './_Item/ShowMoreItem';
import { classnames } from '@src/utils/classnames';

import styled from './ShowMore.scss';

export const ShowMore: FC<IShowMoreProps> = ({
  children,
  htmlContent,
  textSeparator = SEPARATOR,
  maxItems = 3,
  btnView = 'textLight',
  btnSize,
  inline,
  alignButton = 'left',
  className,
  isToggle,
  useSmallBtnPadding,
  maxItemContainerHeight,
  onShowAll,
  disableAnimation,
  collapseClasses,
}) => {
  const [showAll, setShowAll] = useState(false);
  /** Состояние показывающее фактическое значение коллапса с учетом анимации */
  const [collapseOpened, setCollapseOpened] = useState(showAll);
  const classes = classnames(className, styled.root);
  const containerClasses = classnames(styled.container, {
    [styled.containerOverflow_hidden]: !!maxItemContainerHeight && !collapseOpened,
    [styled.containerOverflow_auto]: !!maxItemContainerHeight && collapseOpened,
  });

  const { first, second, isTwoParts, isArray } = useMemo(
    () => separateContent({ htmlContent, textSeparator, maxItems }),
    [htmlContent, textSeparator, maxItems],
  );

  const onShowMore = () => {
    setShowAll(!showAll);
    onShowAll?.(!showAll);
  };

  return (
    <Box column className={classes}>
      <div className={containerClasses} style={{ maxHeight: maxItemContainerHeight }}>
        <ShowMoreItem data={first} />

        {children}

        {isTwoParts && (
          <Collapse
            className={collapseClasses}
            open={showAll}
            inline={inline}
            onExit={() => maxItemContainerHeight && setCollapseOpened(false)}
            onEntered={() => maxItemContainerHeight && setCollapseOpened(true)}
            disableAnimation={disableAnimation}
          >
            <Box column>
              <ShowMoreItem data={second} />
            </Box>
          </Collapse>
        )}
      </div>

      {isTwoParts && (!showAll || isToggle) && (
        <ShowMoreButton
          align={alignButton}
          view={btnView}
          size={btnSize}
          isShowAll={showAll}
          useSmallBtnPadding={useSmallBtnPadding ?? isArray}
          onClick={onShowMore}
        />
      )}
    </Box>
  );
};
